import JsonLd from '@/components/JsonLd'
import { webPageSchema, breadcrumbSchema } from '@/lib/jsonLdSchemas'
import Navbar from '@/components/layout/Navbar'
import Footer from '@/components/layout/Footer'

export default function TermsOfService() {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50 font-sans text-primary selection:bg-accent selection:text-white">
      <JsonLd data={webPageSchema({ name: 'Terms of Service', description: 'Terms and conditions for using Gigafish services and website.', path: '/terms' })} />
      <JsonLd data={breadcrumbSchema([{ name: 'Terms of Service', path: '/terms' }])} />
      <Navbar />
      <main className="relative flex-1 pt-36 pb-28 md:pt-40 md:pb-32">
        <div className="absolute inset-0 bg-[url('/assets/bg-noise.png')] opacity-[0.035] mix-blend-multiply pointer-events-none" />
        <div className="container relative z-10 max-w-2xl mx-auto px-8">
          <h1 className="text-4xl md:text-5xl font-bold font-heading text-primary uppercase tracking-tight mb-12">
            Terms of Service
          </h1>

          <div className="space-y-8 text-slate-600 leading-relaxed">
            <section>
              <h2 className="text-xl font-bold text-primary mb-4">1. Agreement to Terms</h2>
              <p>
                By accessing or using the Gigafish website (gigafish.co) and our services, you agree to be bound by these Terms of Service. If you do not agree, please do not use our website or services.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-primary mb-4">2. Our Services</h2>
              <p>
                Gigafish provides digital agency services including strategy, marketing, design, development, and analytics. Specific deliverables, timelines, and fees are set out in individual project agreements or statements of work.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-primary mb-4">3. Client Obligations</h2>
              <p>As a client, you agree to:</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Provide accurate information and timely feedback</li>
                <li>Make payments as agreed in project agreements</li>
                <li>Obtain any necessary approvals or licences for materials you provide</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-primary mb-4">4. Intellectual Property</h2>
              <p>
                Unless otherwise agreed in writing, intellectual property in work we create for you transfers to you upon full payment. We retain the right to use anonymised work in our portfolio and for promotional purposes.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-primary mb-4">5. Limitation of Liability</h2>
              <p>
                To the fullest extent permitted by law, our liability is limited to the fees paid for the relevant project. We are not liable for indirect, consequential, or incidental damages.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-primary mb-4">6. Termination</h2>
              <p>
                Either party may terminate a project agreement in accordance with its terms. We may suspend or terminate access to our website or client portal for breach of these terms.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-primary mb-4">7. Changes</h2>
              <p>
                We may update these Terms of Service from time to time. Continued use of our website or services after changes constitutes acceptance of the updated terms.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-primary mb-4">8. Contact</h2>
              <p>
                For questions about these Terms of Service, contact us at{' '}
                <a href="mailto:hello@gigafish.co" className="text-accent underline hover:no-underline">hello@gigafish.co</a>.
              </p>
            </section>
          </div>

          <hr className="border-slate-200 mt-12 mb-6" />
          <p className="text-slate-500 text-xs">Last updated: {new Date().toLocaleDateString('en-AU')}</p>
        </div>
      </main>
      <Footer />
    </div>
  )
}
